var render = function render(){var _vm=this,_c=_vm._self._c;return _c('El',_vm._b({attrs:{"tag":"ion-row","mb":_vm.mb}},'El',_vm.$attrs,false),[_c('El',{attrs:{"tag":"ion-col","size":"1","ml":5}},[_vm._t("indicator")],2),_c('El',{staticClass:"description",attrs:{"tag":"ion-col","ml":15,"pt":4,"color":"text.secondary"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }